import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream px-3 py-5 sm:py-7" data-id="element-73" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-xl border-2 border-turq/50 bg-white p-3.5 shadow-sm sm:p-5" data-id="element-74" data-mp="1o3dnoel7yhs7">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-mint text-turq" data-id="element-75" data-mp="1x4bpcq86qd7m">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-76" data-mp="19e7p8su7gvld" />
        </span>
        <div data-id="element-77" data-mp="14fo2wrbp9hsh">
          <h2 className="text-lg leading-tight text-teal sm:text-2xl" data-id="element-78" data-mp="14fxps61g78ty">
            Your purchase is 100% protected
          </h2>
          <p className="mt-1 text-[13px] font-medium leading-snug text-charcoal/80 sm:text-base" data-id="element-79" data-mp="1j5c3trfyyefo">
            Explore FONO KIDS PRO™ for 30 days. Review the six activity modules, visual
            materials, printable cards, games, scenes, sequencing resources and five
            professional bonuses. If the system isn’t right for you, contact us within 30
            days for a full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}